import { App } from "app";
import { createRoot } from "react-dom/client";

import { installOfflineWriteGuard } from "common/utils/offlineWriteGuard";
import { installUnhandledRejectionHandler } from "common/utils/unhandledRejectionHandler";
import { analytics } from "./common/analytics";
import { AnalyticsEvents } from "./common/analytics/events";

installUnhandledRejectionHandler();

// Register global properties and track session start
analytics.register({ gitsha: import.meta.env.VITE_GITSHA ?? "" });
analytics.track(AnalyticsEvents.SESSION_STARTED);

// Block writes to our API while offline (single network choke point).
installOfflineWriteGuard();

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
